import React, { useEffect } from "react";
// react-redux
import { useDispatch, useSelector } from "react-redux";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
// components
import MainSlickSlider from "../../components/SlickSlider/MainSlickSlider";
import TabList from "../../components/TabList/TabList";
import Header from "../../components/Header/Header";
// styles
import styles from "./aboutViewStyle";
// action
import {
  fetchSiteBasicInfo,
  fetchAboutInfo,
} from "../../store/actions/WordPressApiAction";

const useStyles = makeStyles(styles);

export default function AboutView(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const basicInfo = useSelector((state) => state.fetchBasicInfoReducer);
  const aboutInfo = useSelector((state) => state.fetchAboutInfoReducer);

  //サイト基本情報取得
  useEffect(() => {
    dispatch(fetchSiteBasicInfo());
    dispatch(fetchAboutInfo());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.aboutContainer}>
      <Header
        brand={basicInfo.site_title}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
      />
      <MainSlickSlider headerInfo={basicInfo.header_info} />

      {aboutInfo.map((item, index) => {
        return (
          <div key={index}>
            <div className={classes.title}>{item.title}</div>
            <TabList tabList={item.tab_list} />
          </div>
        );
      })}
    </div>
  );
}
